// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
/* SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>

SPDX-License-Identifier: AGPL-3.0-only
*/
html {
  /* Force scrollbar to always show. Prevents layout shift when it appears */
  overflow-y: scroll;
}

body {
  margin: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  background-color: white;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* SVG.js uses this off-screen surface for chart measurements, not page content.
   Keep it measurable while excluding it from the accessibility tree. */
body > svg[id^="SvgjsSvg"][width="2"][height="0"] {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;EACE,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2DAA2D;EAC3D,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;aACW;AACb;;AAEA;uEACuE;AACvE;EACE,kBAAkB;AACpB","sourcesContent":["/*\n/* SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>\n\nSPDX-License-Identifier: AGPL-3.0-only\n*/\nhtml {\n  /* Force scrollbar to always show. Prevents layout shift when it appears */\n  overflow-y: scroll;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: black;\n  background-color: white;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* SVG.js uses this off-screen surface for chart measurements, not page content.\n   Keep it measurable while excluding it from the accessibility tree. */\nbody > svg[id^=\"SvgjsSvg\"][width=\"2\"][height=\"0\"] {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
